import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import NuxtLoading from './components/nuxt-loading.vue';
import '../node_modules/@web/shared-digital-library/css/custom-grid.css';
import '../node_modules/@web/shared-digital-library/css/fluid-font.css';
import '../assets/scss/app.scss';

var _77180f1e = function _77180f1e() {
  return import('../layouts/blank.vue'
  /* webpackChunkName: "layouts/blank" */
  ).then(function (m) {
    return m.default || m;
  });
};

var _6f6c098b = function _6f6c098b() {
  return import('../layouts/default.vue'
  /* webpackChunkName: "layouts/default" */
  ).then(function (m) {
    return m.default || m;
  });
};

var _77430317 = function _77430317() {
  return import('../layouts/empty.vue'
  /* webpackChunkName: "layouts/empty" */
  ).then(function (m) {
    return m.default || m;
  });
};

var layouts = {
  "_blank": _77180f1e,
  "_default": _6f6c098b,
  "_empty": _77430317
};
var resolvedLayouts = {};
export default {
  head: {
    "meta": [{
      "charset": "utf-8"
    }, {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }, {
      "http-equiv": "X-UA-Compatible",
      "content": "IE=edge,chrome=1"
    }],
    "link": [{
      "rel": "icon",
      "type": "image/x-icon",
      "href": "/favicon.ico"
    }],
    "style": [],
    "script": []
  },
  render: function render(h, props) {
    var loadingEl = h('NuxtLoading', {
      ref: 'loading'
    });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);
    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter: function beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(function () {
            window.$nuxt.$emit('triggerScroll');
          });
        }
      }
    }, [templateEl]);
    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },
  data: function data() {
    return {
      isOnline: true,
      layout: null,
      layoutName: ''
    };
  },
  beforeCreate: function beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created: function created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this; // add to window so we can listen when ready

    if (process.client) {
      window.$nuxt = this;
      this.refreshOnlineStatus(); // Setup the listeners

      window.addEventListener('online', this.refreshOnlineStatus);
      window.addEventListener('offline', this.refreshOnlineStatus);
    } // Add $nuxt.error()


    this.error = this.nuxt.error;
  },
  mounted: function mounted() {
    this.$loading = this.$refs.loading;
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  computed: {
    isOffline: function isOffline() {
      return !this.isOnline;
    }
  },
  methods: {
    refreshOnlineStatus: function refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true;
        } else {
          this.isOnline = window.navigator.onLine;
        }
      }
    },
    errorChanged: function errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail();
        if (this.$loading.finish) this.$loading.finish();
      }
    },
    setLayout: function setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default';
      this.layoutName = layout;

      var _layout = '_' + layout;

      this.layout = resolvedLayouts[_layout];
      return this.layout;
    },
    loadLayout: function loadLayout(layout) {
      var _this = this;

      var undef = !layout;
      var nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout]);

      var _layout = '_' + (undef || nonexistent ? 'default' : layout);

      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout]);
      }

      return layouts[_layout]().then(function (Component) {
        resolvedLayouts[_layout] = Component;
        delete layouts[_layout];
        return resolvedLayouts[_layout];
      }).catch(function (e) {
        if (_this.$nuxt) {
          return _this.$nuxt.error({
            statusCode: 500,
            message: e.message
          });
        }
      });
    }
  },
  components: {
    NuxtLoading: NuxtLoading
  }
};